export enum PermissionTypes {
    EDIT_CONTRACT_DATA
}

export default PermissionTypes;
